import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
// import Loader from "react-loader-spinner";

import { useAlert } from "react-alert";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { useDispatch, useSelector } from "react-redux";
import { getStudents } from "../../../../actions/adminStudentActions";
import { deleteStudentData } from "../../../../actions/adminStudentActions";
import Loader from "../../../Loader";

const ListStudents = ({ history }) => {
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const pageSize = 10;
  // const [Customers, setCustomersData] = useState({});

  const alert = useAlert();
  const dispatch = useDispatch();

  const {
    students: studentList = [],
    user_loading,
  } = useSelector((state) => state.students || {});

  useEffect(() => {
    dispatch(getStudents());
  }, [dispatch, refresh]);

  useEffect(() => {
    setPage(1);
  }, [studentList.length]);

  const totalPages = Math.max(1, Math.ceil(studentList.length / pageSize));

  const filteredStudents = useMemo(() => {
    const from = fromDate ? new Date(fromDate).getTime() : null;
    const to = toDate ? new Date(toDate).getTime() : null;
    const query = (searchTerm || "").toLowerCase().trim();

    const filtered = studentList.filter((user) => {
      const created = user?.createdAt ? new Date(user.createdAt).getTime() : null;
      if (from && (!created || created < from)) return false;
      if (to && (!created || created > to + 24 * 60 * 60 * 1000 - 1)) return false;

      if (!query) return true;

      const fullName = `${user?.first_name || ""} ${user?.last_name || ""}`.toLowerCase();
      const email = (user?.email || "").toLowerCase();
      const mobile = `${user?.mobile_code || ""} ${user?.mobile_number || ""}`.toLowerCase();

      return (
        fullName.includes(query) ||
        email.includes(query) ||
        mobile.includes(query)
      );
    });

    // Sort by createdAt descending (newest first)
    return filtered.sort((a, b) => {
      const dateA = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
      const dateB = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
      return dateB - dateA;
    });
  }, [studentList, fromDate, toDate, searchTerm]);

  const pagedStudents = useMemo(() => {
    const start = (page - 1) * pageSize;
    return filteredStudents.slice(start, start + pageSize);
  }, [filteredStudents, page, pageSize]);

  const handleExport = () => {
    if (!studentList.length) {
      alert.info("No students to export");
      return;
    }

    const rows = filteredStudents.map((user) => ({
      Name: `${user.first_name || ""} ${user.last_name || ""}`.trim(),
      Email: user.email || "",
      Mobile: `${user.mobile_code || ""} ${user.mobile_number || ""}`.trim(),
      Status: user.accountStatus || "",
      CreatedAt: user.createdAt || "",
    }));

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Students");
    XLSX.writeFile(wb, "students.xlsx");
  };

  const handleDeleteUser = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(deleteStudentData(id));
            alert.success("Student deleted successfully");
            // dispatch(getStudents());
            setRefresh((prev) => !prev);
            // history.push(`/admin/students`);
          },
        },
        {
          label: "No",
          onClick: () => alert.success("No data deleted"),
        },
      ],
    });
  };

  return (
    <Fragment>
      <div className="content-wrapper">
        <section className="content-header">
          <h1>
            Manage
            <small>Students</small>
          </h1>
          <ol className="breadcrumb">
            <li>
              <Link to="/admin">
                <i className="fa fa-dashboard"></i> Dashboard
              </Link>
            </li>
            <li className="active">Students</li>
          </ol>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-xs-12">
              <div className="box">
                <div className="box-header">
                  <h3 className="box-title">Students</h3>
                  {/*&nbsp;
                              &nbsp;
                              &nbsp;
                              &nbsp;
                              <p className="box-title">
                                <Link to={"/admin/users/add"} className="">+ Add Admin User</Link>
                              </p>*/}

                  <div
                    className="box-tools"
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <Link
                      to={"/admin/students/add"}
                      className="btn btn-sm btn-success"
                    >
                      + Add New Student
                    </Link>
                    <Link
                      to={"/admin/students/import"}
                      className="btn btn-sm btn-info"
                    >
                      <i className="fa fa-upload"></i> Import
                    </Link>
                    <Link
                      to={"/admin/email-campaign"}
                      className="btn btn-sm btn-warning"
                    >
                      <i className="fa fa-envelope"></i> Email members
                    </Link>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={handleExport}
                    >
                      Export Excel
                    </button>
                    <input
                      type="text"
                      className="form-control input-sm"
                      style={{ width: "200px" }}
                      placeholder="Search name, email or phone"
                      value={searchTerm}
                      onChange={(e) => {
                        setPage(1);
                        setSearchTerm(e.target.value);
                      }}
                      aria-label="Search students"
                    />
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <span style={{ fontSize: "12px" }}>From</span>
                      <input
                        type="date"
                        className="form-control input-sm"
                        style={{ width: "140px" }}
                        value={fromDate}
                        onChange={(e) => {
                          setPage(1);
                          setFromDate(e.target.value);
                        }}
                        aria-label="From date"
                      />
                      <span style={{ fontSize: "12px" }}>To</span>
                      <input
                        type="date"
                        className="form-control input-sm"
                        style={{ width: "140px" }}
                        value={toDate}
                        onChange={(e) => {
                          setPage(1);
                          setToDate(e.target.value);
                        }}
                        aria-label="To date"
                      />
                    </div>
                  </div>
                </div>
                <div className="box-body table-responsive no-padding">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile Number</th>
                        <th>Status</th>
                        <th>Date Joined</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {user_loading ? (
                        <Loader />
                      ) : pagedStudents.length ? (
                        pagedStudents.map((user) => (
                          <tr key={user._id}>
                            <td>
                              {user.first_name} {user.last_name}
                            </td>
                            <td>{user.email}</td>
                            <td>
                              {user.mobile_code} {user.mobile_number}
                            </td>
                            <td>
                              {user.accountStatus === "Active" && (
                                <span className="label bg-green">
                                  {user.accountStatus}
                                </span>
                              )}
                              {user.accountStatus === "InActive" && (
                                <span className="label bg-yellow">
                                  {user.accountStatus}
                                </span>
                              )}
                              {user.accountStatus === "Blocked" && (
                                <span className="label bg-red">
                                  {user.accountStatus}
                                </span>
                              )}
                              {user.accountStatus === "Suspended" && (
                                <span className="label bg-gray">
                                  {user.accountStatus}
                                </span>
                              )}
                            </td>
                            <td>{user.createdAt ? new Date(user.createdAt).toLocaleDateString() : "-"}</td>
                            <td>
                              <Link
                                to={`/admin/students/edit/${user._id}`}
                                className="btn btn-success btn-sm"
                                title="Edit"
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                              &nbsp;
                              <a
                                className="btn btn-danger btn-sm"
                                title="Delete"
                                onClick={() => handleDeleteUser(user._id)}
                                key={user._id}
                              >
                                <i className="fa fa-trash"></i>
                              </a>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">No records found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {studentList.length > pageSize && (
                  <div className="box-footer clearfix">
                    <div className="pull-left">
                      Page {page} of {totalPages}
                    </div>
                    <div className="pull-right">
                      <button
                        type="button"
                        className="btn btn-default btn-sm"
                        disabled={page === 1}
                        onClick={() => setPage((p) => Math.max(1, p - 1))}
                      >
                        Prev
                      </button>
                      &nbsp;
                      <button
                        type="button"
                        className="btn btn-default btn-sm"
                        disabled={page === totalPages}
                        onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </Fragment>
  );
};

export default ListStudents;
